import { html } from '../core/html.js';
import { t } from '../core/i18n.js';
import { page, breadcrumbs } from '../components/chrome.js';
import { icon } from '../components/icon.js';
import { site } from '../data/site.js';

const FIELDS = [
  { name: 'name', type: 'text', labelKey: 'contact.form.name', autocomplete: 'name' },
  { name: 'email', type: 'email', labelKey: 'contact.form.email', autocomplete: 'email' },
];

const expectItems = [1, 2, 3];

export const ContactPage = () => page(html`
  <section class="pagehead" aria-labelledby="contact-title">
    <div class="shell">
      ${breadcrumbs('nav.contact')}
      <div class="pagehead__grid">
        <div>
          <p class="kicker">${t('contact.label')}</p>
          <h1 class="pagehead__title" id="contact-title">${t('contact.title')}</h1>
          <p class="pagehead__lede">${t('contact.lede')}</p>
        </div>
        <aside class="pagehead__aside">
          <p class="kicker">${t('contact.aside.label')}</p>
          <p class="pagehead__note">
            <strong>${t('contact.info.email')}</strong><br />
            <a class="contact-mail" href="mailto:${site.email}">
              ${site.email}${icon('arrowRight', { size: 18 })}
            </a>
          </p>
          <p class="pagehead__meta">${site.address.city} · ${site.address.countryCode}</p>
        </aside>
      </div>
    </div>
  </section>

  <section class="section" aria-labelledby="form-title">
    <div class="shell contact-layout">
      <div class="form-panel">
        <div class="form-panel__head">
          <h2 class="form-panel__title" id="form-title">${t('contact.form.title')}</h2>
          <p class="form-panel__hint">${t('contact.form.hint')}</p>
        </div>

        <form id="contactForm" class="form" novalidate>
          <div class="form__row form__row--split">
            ${FIELDS.map(
              (field) => html`
                <p class="field">
                  <label class="field__label" for="${field.name}">${t(field.labelKey)}</label>
                  <input
                    class="field__input"
                    id="${field.name}"
                    name="${field.name}"
                    type="${field.type}"
                    autocomplete="${field.autocomplete}"
                    required
                  />
                </p>
              `,
            )}
          </div>

          <p class="field">
            <label class="field__label" for="subject">${t('contact.form.subject')}</label>
            <input class="field__input" id="subject" name="subject" type="text" required />
          </p>

          <p class="field">
            <label class="field__label" for="message">${t('contact.form.message')}</label>
            <textarea class="field__input" id="message" name="message" rows="7" required></textarea>
          </p>

          <div class="form__actions">
            <button class="btn btn--ink btn--lg" type="submit" id="submitBtn">
              ${t('contact.form.send')}${icon('mail', { size: 17 })}
            </button>
          </div>
          <p class="form__status" id="formStatus" role="status" aria-live="polite"></p>
        </form>
      </div>

      <aside class="contact-aside">
        <div class="contact-block">
          <p class="contact-block__label">${t('contact.info.address')}</p>
          <p>
            ${site.legalName}<br />
            ${site.address.street}<br />
            ${site.address.postalCode} ${site.address.city}
          </p>
        </div>
        <div class="contact-block">
          <p class="contact-block__label">${t('contact.info.company')}</p>
          <p>${site.register.number}<br />${site.register.court}</p>
        </div>

        <div class="expect">
          <div>
            <p class="kicker">${t('contact.expect.label')}</p>
            <h2 class="expect__title">${t('contact.expect.title')}</h2>
          </div>
          <p class="expect__text">${t('contact.expect.description')}</p>
          <ol class="expect__list">
            ${expectItems.map(
              (index) => html`
                <li class="expect__item">
                  <span class="expect__num" aria-hidden="true">${String(index).padStart(2, '0')}</span>
                  <h3>${t(`contact.expect.item${index}.title`)}</h3>
                  <p>${t(`contact.expect.item${index}.text`)}</p>
                </li>
              `,
            )}
          </ol>
        </div>
      </aside>
    </div>
  </section>
`);
